import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';

import { Currency, Invoice } from 'apps-common/types';
import { axiosQuery } from 'apps-common/utils/axiosQuery';

export interface InvoiceResponse {
  account: {
    currency: Currency;
  };
  invoices: Invoice[];
}

const QUERY = gql`
  query BillingHistory {
    accountV2 {
      currency
    }
    invoices {
      id
      amount
      balance
      date
      compensationType
      compensationAmount
    }
  }
`;

type ApiResponse = Omit<InvoiceResponse, 'account'> & { accountV2: InvoiceResponse['account'] };

export const useGetBillingHistory = () =>
  useQuery<InvoiceResponse>({
    queryKey: ['getBillingHistory'],
    queryFn: async () =>
      axiosQuery<ApiResponse>('BillingHistory', QUERY).then((response) => {
        const { accountV2, ...rest } = response;
        return {
          ...rest,
          account: accountV2,
        };
      }),
    refetchOnWindowFocus: false,
    staleTime: 900000, //15min stale
  });
